import type { Theme } from "../types";

export const GALAXY_DARK_COLOR: Theme["color"] = {
  text: {
    primary: "#ffffff",
    primaryAlt: "#101010",
    secondary: "#acacac",
    secondaryAlt: "#3f3f3f",
    tertiary: "#868686",
    tertiaryAlt: "#9e9e9e",
    success: "#6ee4b0",
    warning: "#ffb265",
    error: "#ff6881",
    pink: "#f3a8e5",
    orange: "#ffd2a8",
    yellow: "#fff7aa",
    lime: "#d5f2a7",
    green: "#6ee4b0",
    blue: "#99cffd",
    teal: "#bde8ee",
    purple: "#b7b1f1",
    disabled: "#4d4d4d",
    galaxy: "#0059B8",
    galaxyAlt: "#0060c8",
  },
  background: {
    base: "#131313",
    baseAlt: "#ffffff",
    primary: "#161616",
    primaryAlt: "#fafafa",
    secondary: "#242424",
    secondaryAlt: "#f0f0f0",
    tertiary: "#1B1B1B",
    tertiaryAlt: "#f5f5f5",
    success: "#1d3329",
    successAlt: "#327056",
    warning: "#3f2e19",
    warningAlt: "#2d1900",
    error: "#3d1f24",
    errorAlt: "#AA3247",
    pink: "#361c23",
    pinkAlt: "#f8e6f7",
    orange: "#3d2a12",
    orangeAlt: "#ffe6d2",
    yellow: "#404022",
    yellowAlt: "#faf8d2",
    lime: "#263017",
    limeAlt: "#e4f8c5",
    blue: "#232f3b",
    blueAlt: "#e6f2ff",
    teal: "#2a393c",
    tealAlt: "#e6f7f9",
    purple: "#272442",
    purpleAlt: "#f2f0ff",
    disabled: "#1e1e1e",
    disabledAlt: "#ffffff",
    galaxy: "#0059B8",
    galaxyAlt: "#0060c8",
  },
  border: {
    primary: "#2c2c2c",
    secondary: "#3a3a3a",
    tertiary: "#4a4a4a",
    selected: "#777777",
    success: "#3aa175",
    warning: "#aa6d2f",
    error: "#ac4757",
    disabled: "#2e2e2e",
    lime: "#d5f2a7",
    purple: "#b7b1f1",
    galaxy: "#0059B8",
    galaxyAlt: "#0060c8",
  },
  icon: {
    primary: "#ffffff",
    primaryAlt: "#000000",
    secondary: "#acacac",
    secondaryAlt: "#000000",
    tertiary: "#868686",
    tertiaryAlt: "#000000",
    success: "#55c393",
    warning: "#ffb265",
    error: "#f3506b",
    pink: "#f3a8ef",
    orange: "#ffd2a8",
    yellow: "#fff7aa",
    lime: "#d5f2a7",
    blue: "#99cffd",
    teal: "#bde8ee",
    purple: "#b7b1f1",
    disabled: "#4d4d4d",
    galaxy: "#0059B8",
    galaxyAlt: "#0060c8",
  },
  opacity: {
    bw100: "rgba(0, 0, 0, 1)",
    bw100Alt: "rgba(255, 255, 255, 1)",
    bw80: "rgba(0, 0, 0, 0.8)",
    bw80Alt: "rgba(255, 255, 255, 0.8)",
    bw64: "rgba(0, 0, 0, 0.64)",
    bw64Alt: "rgba(255, 255, 255, 0.64)",
    bw48: "rgba(0, 0, 0, 0.48)",
    bw48Alt: "rgba(255, 255, 255, 0.48)",
    bw32: "rgba(0, 0, 0, 0.32)",
    bw32Alt: "rgba(255, 255, 255, 0.32)",
    bw24: "rgba(0, 0, 0, 0.24)",
    bw24Alt: "rgba(255, 255, 255, 0.24)",
    bw16: "rgba(0, 0, 0, 0.16)",
    bw16Alt: "rgba(255, 255, 255, 0.16)",
    bw12: "rgba(0, 0, 0, 0.12)",
    bw12Alt: "rgba(255, 255, 255, 0.12)",
    bw8: "rgba(0, 0, 0, 0.08)",
    bw8Alt: "rgba(255, 255, 255, 0.08)",
    b4: "rgba(0, 0, 0, 0.04)",
    b4Alt: "rgba(255, 255, 255, 0.04)",
    bw0: "rgba(0, 0, 0, 0)",
    bw0Alt: "rgba(255, 255, 255, 0)",
  },
};
